// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"93a71f06","703":"11ed9669","787":"d7415f72"}[chunkId] + ".chunk.js";
};